import React from 'react';
import { Button } from '@guildeducationinc/recess';
import { clickable } from '@src/analytics';
import { GENESIS_URL } from '@src/constants';

interface ButtonActionProp {
  product: string;
  applicationId: string;
}

export const ButtonAction: React.FC<ButtonActionProp> = ({ product, applicationId }) => {
  return (
    <Button
      onClick={() =>
        clickable({
          loggedIn: true,
          tag: 'learn_skills',
          text: 'applications_complete_application',
          type: 'button',
          product,
        })
      }
      testid='application-card-button'
      className='applicationCardButton flexSelf--center'
      href={`${GENESIS_URL}/applications/${applicationId}`}
      appearance='outline'
    >
      Complete application
    </Button>
  );
};
